import React, { useState } from "react";

import logo from "../assets/img/Group 46890.svg";
import ukFlag from "../assets/img/flag/flag-united-kingdom.svg";
import nlFlag from "../assets/img/flag/openmoji_flag-netherlands.svg";
import esFlag from "../assets/img/flag/openmoji_flag-spain.svg";
import frFlag from "../assets/img/flag/openmoji_flag-france.svg";
import arFlag from "../assets/img/flag/openmoji_flag-sudan.svg";
import { useTranslation } from "react-i18next";

import { Link, NavLink, useNavigate } from "react-router-dom";

const Header = () => {

  // Mobile Menu
  const [mobileMenu, setMobileMenu] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const handleSearch = (event) => {
    event.preventDefault();
    const query = searchQuery.trim();
    if (!query) return;
    navigate(`/buy?listingType=all&q=${encodeURIComponent(query)}`);
    setSearchOpen(false);
    setSearchQuery("");
    setMobileMenu(false);
  };


const [selectedLang, setSelectedLang] = useState("en");

const flags = {
  en: ukFlag,
  nl: nlFlag,
  es: esFlag,
  fr: frFlag,
  ar: arFlag,
};

  return (
    <header className="w-full bg-white border-b border-gray-200 py-5 px-5 lg:px-8 sticky top-0 z-[999]">

      <div className="max-w-[1400px] mx-auto flex items-center justify-between">

        {/* ================= LOGO ================= */}
        <Link to="/">

          <img
            src={logo}
            alt="Benzies"
            className="w-[110px] lg:w-[100px] object-contain"
          />

        </Link>

        {/* ================= DESKTOP MENU ================= */}
        <nav className="hidden lg:flex items-center gap-10">

          <NavLink
            to="/"
            end
            className={({ isActive }) => `text-[18px] font-medium transition ${isActive ? "border-b-2 border-[#0B122B] text-[#0B122B]" : "text-black hover:text-gray-600"}`}
          >
            Home
          </NavLink>

          <NavLink
            to="/buy"
            className={({ isActive }) => `text-[18px] font-medium transition ${isActive ? "border-b-2 border-[#0B122B] text-[#0B122B]" : "text-black hover:text-gray-600"}`}
          >
            Buy
          </NavLink>

          <NavLink
            to="/rent"
            className={({ isActive }) => `text-[18px] font-medium transition ${isActive ? "border-b-2 border-[#0B122B] text-[#0B122B]" : "text-black hover:text-gray-600"}`}
          >
            Rent
          </NavLink>

          <NavLink
            to="/sell"
            className={({ isActive }) => `text-[18px] font-medium transition ${isActive ? "border-b-2 border-[#0B122B] text-[#0B122B]" : "text-black hover:text-gray-600"}`}
          >
            Sell
          </NavLink>

          <NavLink
          to="/concierge"
          className={({ isActive }) => `text-[18px] font-medium transition ${isActive ? "border-b-2 border-[#0B122B] text-[#0B122B]" : "text-black hover:text-gray-600"}`}
          >
          Concierge
         </NavLink>

          <NavLink
            to="/about"
            className={({ isActive }) => `text-[18px] font-medium transition ${isActive ? "border-b-2 border-[#0B122B] text-[#0B122B]" : "text-black hover:text-gray-600"}`}
          >
            About
          </NavLink>

          <NavLink
            to="/contact"
            className={({ isActive }) => `text-[18px] font-medium transition ${isActive ? "border-b-2 border-[#0B122B] text-[#0B122B]" : "text-black hover:text-gray-600"}`}
          >
            Contact
          </NavLink>

          {/* Search */}
          <button type="button" onClick={() => setSearchOpen((open) => !open)} aria-label="Search properties" className="text-[22px] cursor-pointer text-black hover:text-gray-600 transition">

            <i className="fa-solid fa-magnifying-glass"></i>

          </button>
<div className="notranslate flex items-center gap-2">

  <img
    src={flags[selectedLang]}
    alt="flag"
    className="w-8 h-8"
  />

  <select
    translate="no"
    value={selectedLang}
    className="
      border
      border-gray-300
      rounded-md
      px-3
      py-2
      text-[15px]
      outline-none
      bg-white
    "
    onChange={(e) => {

      const lang = e.target.value;

      setSelectedLang(lang);

      const googleTranslate =
        document.querySelector(".goog-te-combo");

      if (googleTranslate) {

        googleTranslate.value = lang;

        googleTranslate.dispatchEvent(
          new Event("change")
        );

      }

    }}
  >

    <option value="en">EN-English</option>
    <option value="nl">NL-Dutch</option>
    <option value="es">ES-Spanish</option>
    <option value="fr">FR-French</option>
    <option value="ar">AR-Arabic</option>

  </select>

</div>

        </nav>

        {/* ================= MOBILE MENU BUTTON ================= */}
        <button
          onClick={() => setMobileMenu(true)}
          className="lg:hidden text-[28px] text-black"
        >

          <i className="fa-solid fa-bars"></i>

        </button>

      </div>

      {searchOpen && <form onSubmit={handleSearch} className="absolute right-5 top-full z-50 mt-2 flex w-[min(360px,calc(100vw-40px))] gap-2 border border-gray-200 bg-white p-3 shadow-xl lg:right-8">
        <input autoFocus type="search" value={searchQuery} onChange={(event) => setSearchQuery(event.target.value)} placeholder="Search properties..." aria-label="Search properties" className="min-w-0 flex-1 border border-gray-300 px-3 py-2 text-[14px] outline-none focus:border-[#0B122B]" />
        <button type="submit" className="bg-[#0B122B] px-4 py-2 text-white" aria-label="Submit property search">Go</button>
      </form>}

      {/* ================= MOBILE SIDEBAR ================= */}
      <div
  className={`fixed top-0 ${
    mobileMenu ? "right-0" : "-right-full"
  } w-[300px] h-screen overflow-y-auto bg-white shadow-2xl transition-all duration-500 z-[9999] lg:hidden`}
>

        {/* ================= TOP ================= */}
        <div className="flex items-center justify-between px-6 py-6 border-b">

          <Link to="/">

            <img
              src={logo}
              alt="logo"
              className="w-[100px]"
            />

          </Link>

          <button
            onClick={() => setMobileMenu(false)}
            className="text-[28px]"
          >

            <i className="fa-solid fa-xmark"></i>

          </button>

        </div>

        {/* ================= MOBILE LINKS ================= */}
        <div className="flex flex-col px-6 py-6">

          <NavLink
            to="/"
            end
            onClick={() => setMobileMenu(false)}
            className={({ isActive }) => `py-4 text-[18px] border-b ${isActive ? "border-[#0B122B] text-[#0B122B]" : "text-black"}`}
          >
            Home
          </NavLink>

          <NavLink
            to="/buy"
            onClick={() => setMobileMenu(false)}
            className={({ isActive }) => `py-4 text-[18px] border-b ${isActive ? "border-[#0B122B] text-[#0B122B]" : "text-black"}`}
          >
            Buy
          </NavLink>

          <NavLink
            to="/rent"
            onClick={() => setMobileMenu(false)}
            className={({ isActive }) => `py-4 text-[18px] border-b ${isActive ? "border-[#0B122B] text-[#0B122B]" : "text-black"}`}
          >
            Rent
          </NavLink>

          <NavLink
            to="/sell"
            onClick={() => setMobileMenu(false)}
            className={({ isActive }) => `py-4 text-[18px] border-b ${isActive ? "border-[#0B122B] text-[#0B122B]" : "text-black"}`}
          >
            Sell
          </NavLink>

          <NavLink
           to="/concierge"
           onClick={() => setMobileMenu(false)}
           className={({ isActive }) => `py-4 text-[18px] border-b ${isActive ? "border-[#0B122B] text-[#0B122B]" : "text-black"}`}
          >
           Concierge
          </NavLink>

          <NavLink
            to="/about"
            onClick={() => setMobileMenu(false)}
            className={({ isActive }) => `py-4 text-[18px] border-b ${isActive ? "border-[#0B122B] text-[#0B122B]" : "text-black"}`}
          >
            About
          </NavLink>

          <NavLink
            to="/contact"
            onClick={() => setMobileMenu(false)}
            className={({ isActive }) => `py-4 text-[18px] border-b ${isActive ? "border-[#0B122B] text-[#0B122B]" : "text-black"}`}
          >
            Contact
          </NavLink>

          {/* Search */}
          <button type="button" onClick={() => setSearchOpen(true)} className="pt-6 text-[22px] text-left" aria-label="Search properties">

            <i className="fa-solid fa-magnifying-glass"></i>

          </button>

         {/* ================= MOBILE LANGUAGE SELECTOR ================= */}

<div className="notranslate mt-6 flex items-center gap-2">

  <img
    src={flags[selectedLang]}
    alt="flag"
    className="w-8 h-8"
  />

  <select
  value={selectedLang}
    translate="no"
    className="
      w-full
      border
      border-gray-300
      rounded-md
      px-4
      py-3
      text-[16px]
      outline-none
      bg-white
      cursor-pointer
    "
    onChange={(e) => {

      const lang = e.target.value;
      setSelectedLang(lang);

      const googleTranslate = document.querySelector(".goog-te-combo");

      if (googleTranslate) {

        googleTranslate.value = lang;

        googleTranslate.dispatchEvent(new Event("change"));

      }

      setTimeout(() => {

        const banner = document.querySelector(
          "iframe.goog-te-banner-frame"
        );

        if (banner) {
          banner.style.display = "none";
        }

        document.body.style.top = "0px";

      }, 300);

    }}
    defaultValue="en"
  >

    <option value="en" translate="no">EN-English</option>

    <option value="nl" translate="no">NL-Dutch</option>

    <option value="es" translate="no">ES-Spanish</option>

    <option value="fr" translate="no">FR-French</option>

    <option value="ar" translate="no">AR-Arabic</option>

  </select>

</div>

        </div>

      </div>

      {/* ================= OVERLAY ================= */}
      {mobileMenu && (
        <div
          onClick={() => setMobileMenu(false)}
          className="fixed inset-0 bg-black/40 z-[999]"
        ></div>
      )}

    </header>
  );
};

export default Header;